export default __webpack_public_path__ + "static/media/agrieos-logo.0051ac07.png";